<template>
    <ModalComponent
        name="cargar-usuarios"
        title="Cargar usuarios"
        @close="close(false)"
    >
        <b-row>
            <b-col cols="12">
                <div class="form-group">
                    <label for="tipo">Selecciona el tipo de carga de usuarios</label>
                    <ValidationProvider name="tipo">
                        <multiselect 
                            placeholder="Selecciona el tipo de carga de usuarios"
                            :options="tipos"
                            id="tipos"
                            label="label"
                            track-by="id"
                            v-model="tipo"
                            style="z-index: 999;"
                        />
                    </ValidationProvider>
                </div>
            </b-col>
            <template v-if="tipo?.id === 1">
                <b-col cols="12" class="mb-3">
                    <div class="d-md-flex justify-content-between align-items-center mb-2">
                        <label for="listas-abonados">Selecciona una o más listas de las que quieras cargar abonados</label>
                        <Button @click="toggleSeleccionListas">
                            {{ seleccionarTodasListas ? 'Seleccionar todas' : 'Deseleccionar todas' }}
                        </Button>
                    </div>

                    <SelectListaComponent
                        id="listas-abonados"
                        v-model="listas_abonados"
                        :multiple="true"
                        ref="selectListas"
                    />
                    <div class="mt-1">
                        <small><b>* Debes seleccionar al menos una lista.</b></small>
                    </div>
                </b-col>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="6">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox" v-model="renovados" id="renovados"/>
                                <label class="custom-control-label" for="renovados">Abonados activos</label>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox" v-model="no_renovados" id="no_renovados"/>
                                <label class="custom-control-label" for="no_renovados">Abonados no renovados</label>
                            </div>
                        </b-col>
                        <b-col cols="12" class="mt-2">
                            <small><b>* Puedes marcar los dos checks para que se carguen tanto los abonados activos como los no renovados.</b></small>
                        </b-col>
                    </b-row>
                </b-col>
            </template>
            <b-col cols="12" v-if="tipo?.id === 2">
                <div class="form-group" v-if="eventos.length">
                    <div class="d-md-flex justify-content-between align-items-center mb-3">
                        <label for="eventos">Selecciona el evento del que quieres cargar los usuarios</label>
                        <button type="button" class="btn small-button" @click="toggleSeleccionEventos">
                            {{ todosEventosSeleccionados ? 'Quitar todos los eventos' : 'Seleccionar todos los eventos' }}
                        </button>
                    </div>
                    <ValidationProvider name="eventos">
                        <multiselect 
                            placeholder="Eventos"
                            :options="eventos"
                            id="eventos"
                            label="name"
                            track-by="id"
                            v-model="eventosSeleccionados"
                            :multiple="true"
                            :max-height="138"
                        />
                    </ValidationProvider>
                </div>
                <div class="text-center" v-else>
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" v-if="tipo">
                <hr class="my-3"/>
                <h6 class="mb-3">Filtros adicionales (opcionales)</h6>

                <label>Filtrar por rango de edad</label>
                <b-row class="mb-3">
                    <b-col cols="6">
                        <input
                            type="number"
                            maxlength="3"
                            minlength="3"
                            placeholder="Edad mínima"
                            v-model="edad_min"
                        />
                    </b-col>
                    <b-col cols="6">
                        <input
                            type="number"
                            maxlength="3"
                            minlength="3"
                            placeholder="Edad máxima"
                            v-model="edad_max"
                        />
                    </b-col>
                </b-row>
                
                <div class="form-group mb-3">
                    <label>Filtrar por género</label>
                    <multiselect 
                        placeholder="Selecciona un género."
                        :options="generos"
                        label="name"
                        track-by="id"
                        v-model="generosSeleccionados"
                        :multiple="true"
                    />
                </div>

                <div class="form-group mb-3">
                    <label>Filtrar por provincia</label>
                    <multiselect 
                        placeholder="Selecciona una provincia"
                        :options="provincias"
                        label="nombre"
                        track-by="id"
                        v-model="provinciasSeleccionadas"
                        :multiple="true"
                    />
                </div>
            </b-col>
            <b-col cols="12" class="mt-2 text-right">
                <Button @click="cargarUsuarios" :disabled="disabled">
                    Cargar usuarios
                </Button>
            </b-col>
        </b-row>
    </ModalComponent>  
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Generos from "@/mixins/Generos";
    import SelectListaComponent from "@/components/backend/components/listas_abonados/SelectListaComponent";

    export default {
        mixins: [Generos],
        props: {
            comunicado_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                tipo: null,
                eventos: [],
                eventosSeleccionados: [],
                provincias: [],
                provinciasSeleccionadas: [],
                generosSeleccionados: [],
                edad_min: null,
                edad_max: null,
                renovados: true,
                no_renovados: false,
                listas_abonados: [],
                seleccionarTodasListas: true,
                tipos: [
                    { id: 1, label: 'Abonados' },
                    { id: 2, label: 'Eventos' }
                ]
            }
        },
        methods: {
            getEventos() {
                const data = {
                    filters: {
                        to_select: true
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                    this.eventos = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                });
            },
            cargarUsuarios() {
                const data = {
                    filters: {},
                    comunicado_id: this.comunicado_id,
                    tipo: this.tipo.id
                };

                if (this.eventosSeleccionados.length) {
                    data.evento_ids = this.eventosSeleccionados.map(evento => evento.id);
                }

                if (this.generosSeleccionados && this.generosSeleccionados.length) {
                    data.generos = this.generosSeleccionados.map(genero => genero.id);
                }

                if (this.provinciasSeleccionadas && this.provinciasSeleccionadas.length) {
                    data.provincias = this.provinciasSeleccionadas.map(provincia => provincia.id);
                }

                if (this.edad_min ) {
                    data.edad_min = parseInt(this.edad_min);
                }

                if (this.edad_max) {
                    data.edad_max = parseInt(this.edad_max);
                }

                if (this.tipo.id === 1) {
                    if (this.listas_abonados?.length) {
                        data.listas_abonados_ids = this.listas_abonados.map(lista => lista.id);
                    }

                    data.renovados = this.renovados;
                    data.no_renovados = this.no_renovados;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.cargar-users'), data).then(res => {
                    this.$toast.success(res.data?.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                });
            },
            close(recargar) {
                this.tipo = null;
                this.eventosSeleccionados = [];
                this.generosSeleccionados = [];
                this.provinciasSeleccionadas = [];
                this.localidadesSeleccionadas = [];
                this.localidades = [];
                this.$emit('close', 'cargar-usuarios', recargar);
            },
            getProvincias() {
                this.$store.dispatch(this.config.getVuexAlias('select.provincias')).then(res => {
                    this.provincias = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                });
            },
            toggleSeleccionEventos() {
                if (this.todosEventosSeleccionados) {
                    this.eventosSeleccionados = [];
                } else {
                    const idsSeleccionados = this.eventosSeleccionados.map(evento => evento.id);
                    const nuevosEventos = this.eventos.filter(evento => !idsSeleccionados.includes(evento.id));

                    this.eventosSeleccionados = [...this.eventosSeleccionados, ...nuevosEventos];
                }
            },
            toggleSeleccionListas() {
                const todasLasListas = this.$refs.selectListas?.listas || [];

                if (this.seleccionarTodasListas) {
                    this.listas_abonados = [ ...todasLasListas ];
                } else {
                    this.listas_abonados = [];
                }

                this.seleccionarTodasListas = !this.seleccionarTodasListas;
            }
        },
        watch: {
            'tipo.id': function(newVal) {
                if (newVal === 2) {
                    this.getEventos();
                }
            },
            deep: true
        },
        computed: {
            todosEventosSeleccionados() {
                return (
                    this.eventos.length &&
                    this.eventosSeleccionados.length === this.eventos.length
                );
            },
            disabled() {
                return !this.tipo ||
                    (this.tipo.id === 2 && !this.eventosSeleccionados.length) ||
                    (this.tipo.id === 1 && (
                        !this.renovados && !this.no_renovados || 
                        !this.listas_abonados?.length
                    ));
            }
        },
        created() {
            this.getGeneros();
            this.getProvincias();
        },
        components: {
            ModalComponent, SelectListaComponent
        }
    }
</script>